import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://uio-poreznik-production.up.railway.app/api';

const PaymentSuccessPage = () => {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('Aktiviranje pretplate...');
  const [error, setError] = useState(null);
  const [orderNumber, setOrderNumber] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Function to extract order number from URL
    const getOrderNumber = () => {
      const params = new URLSearchParams(location.search);
      return params.get('order_number');
    };

    // Function to verify payment and activate subscription
    const activateSubscription = async () => {
      const orderNum = getOrderNumber();
      console.log("Order number from URL:", orderNum);
      
      if (!orderNum) {
        setError('Broj narudžbe nije pronađen u URL-u.');
        setLoading(false);
        return;
      }
      
      setOrderNumber(orderNum);
      
      try {
        // Call the backend API to verify payment and activate subscription
        console.log(`Calling backend to verify payment: ${API_URL}/payments/verify-monri-success?order_number=${orderNum}`);
        const response = await axios.get(`${API_URL}/payments/verify-monri-success?order_number=${orderNum}`);
        
        console.log("Backend response:", response.data);
        
        if (response.data.success) {
          setMessage('Vaša pretplata je uspješno aktivirana!');
        } else {
          setError(response.data.message || 'Neuspješna aktivacija pretplate.');
        }
      } catch (error) {
        console.error("Error activating subscription:", error);
        
        if (error.response) {
          console.error("Response data:", error.response.data);
          setError(error.response.data.message || 'Greška pri aktivaciji pretplate.');
        } else {
          setError('Greška pri komunikaciji s poslužiteljem. Molimo kontaktirajte podršku.');
        }
      } finally {
        setLoading(false);
      }
    };

    // Activate subscription when component mounts
    activateSubscription();
  }, [location.search]);

  const tryAgain = () => {
    setLoading(true);
    setMessage('Ponovni pokušaj aktivacije pretplate...');
    setError(null);
    
    axios.get(`${API_URL}/payments/verify-monri-success?order_number=${orderNumber}`)
      .then(response => {
        console.log("Retry response:", response.data);
        if (response.data.success) {
          setMessage('Vaša pretplata je uspješno aktivirana!');
          setError(null);
        } else {
          setError(response.data.message || 'Neuspješna aktivacija pretplate.');
        }
      })
      .catch(error => {
        console.error("Error in retry:", error);
        setError('Greška pri ponovnom pokušaju. Molimo kontaktirajte podršku.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="payment-success-container">
      <div className="payment-result-card">
        {loading ? (
          <>
            <div className="loading-indicator">
              <div className="dots">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </div>
            <p>{message}</p>
          </>
        ) : error ? (
          <>
            <div className="payment-error-icon">❌</div>
            <h2>Problem s aktivacijom pretplate</h2>
            <p>{error}</p>
            {orderNumber && <p>Broj narudžbe: {orderNumber}</p>}
            <div className="button-group">
              <button 
                className="primary-button" 
                onClick={tryAgain}
              >
                Pokušaj ponovno
              </button>
              <button 
                className="secondary-button" 
                onClick={() => navigate('/app/settings')}
              >
                Postavke
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="payment-success-icon">✓</div>
            <h2>Hvala na uplati!</h2>
            <p>{message}</p>
            <button 
              className="primary-button" 
              onClick={() => navigate('/app/chat')}
            >
              Započnite razgovor
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccessPage;